export interface ShowBriefingBookPayload {
  question: string;
  answer: string;
}

/**
 * Briefing book drawer — slides up from the bottom-left when Merlin
 * looks up an FAQ entry. Shows the canonical Q&A so the caller can
 * read the official answer while the conversation continues.
 *
 * Mirrors the transcript drawer pattern: fixed position, close button,
 * Esc-dismissable.
 */
export class BriefingBook {
  private readonly root: HTMLElement;
  private readonly questionEl: HTMLElement;
  private readonly answerEl: HTMLElement;

  constructor(root: HTMLElement) {
    this.root = root;
    this.root.innerHTML = `
      <div class="briefing-header">
        <h3>Briefing Book</h3>
        <button class="btn-icon" data-action="close" aria-label="Close briefing book">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M18.3 5.71 12 12l6.3 6.29-1.41 1.42L10.59 13.4 4.29 19.71 2.88 18.3 9.18 12 2.88 5.71 4.29 4.3l6.3 6.29 6.29-6.29z"/>
          </svg>
        </button>
      </div>
      <div class="briefing-body">
        <div class="briefing-question"></div>
        <div class="briefing-answer"></div>
      </div>
    `;
    this.questionEl = this.root.querySelector('.briefing-question')!;
    this.answerEl = this.root.querySelector('.briefing-answer')!;
    this.root.addEventListener('click', (e) => {
      const t = e.target as HTMLElement;
      if (t.closest('[data-action="close"]')) this.hide();
    });
  }

  show(payload: ShowBriefingBookPayload) {
    this.questionEl.textContent = payload.question;
    this.answerEl.textContent = payload.answer;
    this.root.classList.add('open');
  }

  hide() {
    this.root.classList.remove('open');
  }

  get isOpen(): boolean {
    return this.root.classList.contains('open');
  }
}
